import { Fab, Typography } from "@mui/material";
import React from "react";
import { Translate } from "orion-components/i18n";
import { Refresh } from "@mui/icons-material";

const styles = {
	wrapper: {
		display: "flex",
		alignItems: "center",
		flex: "auto",
		flexDirection: "column",
		justifyContent: "center",
		padding: "2.5% 8%",
		width: "100%",
		boxSizing: "border-box",
		overflow: "visible",
		zIndex: 1901,
		fontSize: 14
	},
	button: {
		zIndex: 99,
		marginTop: 12
	},
	refresh: { color: "#FFF" }
};
const StreamFailed = ({ retryStream, message }) => {
	return (
		<div className="camera-text-wrapper" style={styles.wrapper} data-testid="orion-components-cbcomponents-video-web-rtcplayer-wowza-utils-stream-failed-div">
			<Typography
				align="center"
				variant="subtitle1"
				style={{
					fontSize: "1em",
					width: "100%",
					paddingInline: "0.25em",
					boxSizing: "border-box",
					whiteSpace: "normal",
					overflow: "visible",
					overflowWrap: "anywhere",
					wordBreak: "break-word"
				}}
			>
				{message ? message : <Translate value="global.CBComponents.video.webRTCPlayer.camProblem" />}
			</Typography>
			<Fab style={styles.button} color="primary" onClick={retryStream} size="small" data-testid="orion-components-cbcomponents-video-web-rtcplayer-wowza-utils-stream-failed-fab">
				<Refresh style={styles.refresh} />
			</Fab>
		</div>
	);
};

export default StreamFailed;
